export default __webpack_public_path__ + "static/haufige-fragen-amd-0b215e129b84eb2879af5f58b2eaaea0.jpg";